import type { AdaptiveTierState } from '~/lib/useAdaptiveTier';

import { createContext, use } from 'react';

export const TierContext = createContext<AdaptiveTierState | null>(null);

/**
 * @returns The shared adaptive-tier state; throws when called outside a `TierProvider`
 */
export function useTier(): AdaptiveTierState {
  const state = use(TierContext);
  if (null === state) {
    throw new Error('useTier must be used within a TierProvider');
  }
  return state;
}
